import { createListenerMiddleware, createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit";

type TNotification = {
    isDisplayed: boolean;
    message: string;
    type: "success" | "info" | "warning" | "error";
}

type TNotificationSlice = {
    notification: TNotification;
}

const initialState: TNotificationSlice = {
    notification: {
        isDisplayed: false,
        message: '',
        type: 'info'
    },
}

const notificationSlice = createSlice({
    name: 'notification',
    initialState: initialState as any,
    reducers: {
        reset: () => initialState,
        setNewNotification: (state, action: PayloadAction<{
            message: string,
            type: "success" | "info" | "warning" | "error"
        }>) => {
            state.notification = { ...action.payload, isDisplayed: true };
        },
        hideNotification: (state) => {
            state.notification.isDisplayed = false;
            state.notification.message = '';
        },
    }
});

export const {
    reset,
    setNewNotification,
    hideNotification
} = notificationSlice.actions;

export default notificationSlice.reducer;

export const selectNotification = (state: any): TNotification => state.notification.notification;

const notificationListenerMiddleware = createListenerMiddleware();

notificationListenerMiddleware.startListening({
    matcher: isAnyOf(setNewNotification),
    effect: async () => {
        // TODO
    }
});

export { notificationListenerMiddleware };